export const NR01_STOCKGRUPPE_GET = 'NR01_STOCKGRUPPE_GET';
export const NR01_STOCKGRUPPE_SUCCESS = 'NR01_STOCKGRUPPE_SUCCESS';
export const NR01_STOCKGRUPPE_FAILURE = 'NR01_STOCKGRUPPE_FAILURE';

export const NR01_STOCKGRUPPE_LOAD_MORE = 'NR01_STOCKGRUPPE_LOAD_MORE';
export const NR01_STOCKGRUPPE_LOAD_MORE_SUCCESS = 'NR01_STOCKGRUPPE_LOAD_MORE_SUCCESS';
export const NR01_STOCKGRUPPE_LOAD_MORE_FAILURE = 'NR01_STOCKGRUPPE_LOAD_MORE_FAILURE';

export const NR01_STOCKGRUPPE_DELETE = 'NR01_STOCKGRUPPE_DELETE';
export const NR01_STOCKGRUPPE_DELETE_SUCCESS = 'NR01_STOCKGRUPPE_DELETE_SUCCESS';
export const NR01_STOCKGRUPPE_DELETE_FAILURE = 'NR01_STOCKGRUPPE_DELETE_FAILURE';

export const NR01_STOCKGRUPPE_CREATE = 'NR01_STOCKGRUPPE_CREATE';
export const NR01_STOCKGRUPPE_CREATE_SUCCESS = 'NR01_STOCKGRUPPE_CREATE_SUCCESS';
export const NR01_STOCKGRUPPE_CREATE_FAILURE = 'NR01_STOCKGRUPPE_CREATE_FAILURE';

export const NR01_STOCKGRUPPE_UPDATE = 'NR01_STOCKGRUPPE_UPDATE';
export const NR01_STOCKGRUPPE_UPDATE_SUCCESS = 'NR01_STOCKGRUPPE_UPDATE_SUCCESS';
export const NR01_STOCKGRUPPE_UPDATE_FAILURE = 'NR01_STOCKGRUPPE_UPDATE_FAILURE';

export const NR01_RESET = 'NR01_RESET';
